class DecisionConfidenceCard extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.collection-data') || document;
    this.startValue = this.querySelector('[data-decision-confidence-start]');
    this.durationValue = this.querySelector('[data-decision-confidence-duration]');

    this.scope.addEventListener('change', this.handleSelectionChange);
    this.updateFromSelection();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.handleSelectionChange);
  }

  handleSelectionChange = (event) => {
    if (event.target.matches('input[name="selected_product"]')) {
      this.updateFromSelection(event.target);
    }
  };

  updateFromSelection(selectedCourse = this.scope.querySelector('input[name="selected_product"]:checked')) {
    if (!selectedCourse || selectedCourse.disabled) {
      selectedCourse = this.scope.querySelector('input[name="selected_product"]:not(:disabled)');
    }

    const hasVerifiedCourseFacts = selectedCourse
      && selectedCourse.dataset.courseOnline === 'true'
      && selectedCourse.dataset.courseStart
      && selectedCourse.dataset.courseDuration;

    this.toggleAttribute('data-course-facts-ready', Boolean(hasVerifiedCourseFacts));

    if (!hasVerifiedCourseFacts) return;

    this.startValue.textContent = selectedCourse.dataset.courseStart;
    this.durationValue.textContent = selectedCourse.dataset.courseDuration;
  }
}

if (!customElements.get('decision-confidence-card')) {
  customElements.define('decision-confidence-card', DecisionConfidenceCard);
}
